import React from "react";

// @ts-ignore
import Pdf from "!jsx!./assets/pdf.svg";
// @ts-ignore
import Video from "!jsx!./assets/video.svg";
// @ts-ignore
import Image from "!jsx!./assets/image.svg";
// @ts-ignore
import Link from "!jsx!./assets/link.svg";

const AssetTypes = {
	PDF: { Component: Pdf, label: "PDF" },
	FAB: { Component: Image, label: "FAB" },
	IMG: { Component: Image, label: "IMG" },
	VID: { Component: Video, label: "VID" },
	LINK: { Component: Link, label: "LINK" },
};

export default function AssetTypeLabel({ asset = { type: "", videoTime: null } }) {
	const Asset = AssetTypes[asset?.type] || {};
	return (
		<div className="tw-flex tw-items-center tw-text-[12px] tw-text-text tw-font-light">
			{Asset?.Component ? (
				<Asset.Component className="tw-w-[15px] tw-h-[15px] tw-mr-1" />
			) : null}
			{Asset?.label || asset?.type}
			{asset.videoTime ? ` | ${asset.videoTime}` : null}
		</div>
	);
}